"use client";

import { fetchAuthState } from "@/lib/auth/client";

let cachedAccountId: string | null = null;

/** JMAP account id from login session (Stalwart uses opaque ids, not "me"). */
export async function resolveAccountId(): Promise<string> {
  if (cachedAccountId) return cachedAccountId;
  const auth = await fetchAuthState();
  if (auth.accountId && auth.accountId !== "me") {
    cachedAccountId = auth.accountId;
    return auth.accountId;
  }
  throw new Error("Missing JMAP accountId — sign in again");
}

export function clearJmapAccountCache(): void {
  cachedAccountId = null;
}
